import { Navigate } from 'react-router-dom';
import { IRoute, PortalRoutePath } from '@models';
import { Tr } from '@utils';
import { Permission } from '@services/role';
import { CollaboratorsIcon } from '@components/icons';
import { Collaborators } from './Collaborators';
import { AddCollaborator } from './AddCollaborator';
import { EditCollaborator } from './EditCollaborator';
import { EditInvitation } from './EditInvitation';
import { ManageRoles } from './ManageRoles';

export const COLLABORATORS_ROUTES: IRoute = {
	path: PortalRoutePath.COLLABORATORS,
	icon: <CollaboratorsIcon />,
	text: <Tr.Portal path="collaborators.title" />,
	canActivate: (_route, user) =>
		!!user?.hasPermission([Permission.ROLE_READ, Permission.ROLE_WRITE, Permission.INVITE_USER, Permission.USER_WRITE]) &&
		(user.isSeller(user.role) ? !user.isRoleSwitched() : true),
	children: [
		{
			path: '',
			element: <Collaborators />
		},
		{
			path: 'add-collaborator',
			hideFromMenu: true,
			element: <AddCollaborator />
		},
		{
			path: 'edit-collaborator/:email',
			hideFromMenu: true,
			element: <EditCollaborator />
		},
		{
			path: 'edit-invitation/:email',
			hideFromMenu: true,
			element: <EditInvitation />
		},
		{
			path: 'roles',
			hideFromMenu: true,
			element: <ManageRoles />
		},
		{
			index: true,
			path: '*',
			hideFromMenu: true,
			element: <Navigate to={{ pathname: '..' }} replace />
		}
	]
};
